import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-grid p-pt-5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-1 p-offset-6" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-spin pi-spinner",
    style: {"font-size":"2rem"}
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Map = _resolveComponent("Map")!
  const _component_Records = _resolveComponent("Records")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_Map, { features: _ctx.features }, null, 8, ["features"])
    ]),
    _createVNode(_component_Records, { editable: true })
  ]))
}